import { forwardRef, ReactNode } from 'react'
import Box from '@mui/material/Box'
import Collapse from '@mui/material/Collapse'
import Fade from '@mui/material/Fade'
import Grow from '@mui/material/Grow'
import Slide from '@mui/material/Slide'
import Zoom from '@mui/material/Zoom'

type TransitionProps = {
  children?: ReactNode
  position?: 'top-left' | 'top-right' | 'top' | 'bottom-left' | 'bottom-right' | 'bottom'
  type?: 'grow' | 'fade' | 'collapse' | 'slide' | 'zoom'
  direction?: 'up' | 'down' | 'left' | 'right'
}
const transformOrigins: Record<NonNullable<TransitionProps['position']>, string> = {
  'top-left': '0 0 0',
  'top-right': 'top right',
  top: 'top',
  'bottom-left': 'bottom left',
  'bottom-right': 'bottom right',
  bottom: 'bottom',
}

export const Transitions = forwardRef(
  ({ children, position, type, direction, ...others }: TransitionProps, ref) => {
    const positionSX = { transformOrigin: transformOrigins[position ?? 'top-left'] }

    return (
      <Box ref={ref}>
        {type === 'grow' && (
          <Grow {...others}>
            <Box sx={positionSX}>{children}</Box>
          </Grow>
        )}
        {type === 'collapse' && (
          <Collapse {...others} sx={positionSX}>
            {children}
          </Collapse>
        )}
        {type === 'fade' && (
          <Fade
            {...others}
            timeout={{
              appear: 500,
              enter: 600,
              exit: 400,
            }}
          >
            <Box sx={positionSX}>{children}</Box>
          </Fade>
        )}
        {type === 'slide' && (
          <Slide
            {...others}
            direction={direction}
            timeout={{
              appear: 0,
              enter: 400,
              exit: 200,
            }}
          >
            <Box sx={positionSX}>{children}</Box>
          </Slide>
        )}
        {type === 'zoom' && (
          <Zoom {...others}>
            <Box sx={positionSX}>{children}</Box>
          </Zoom>
        )}
      </Box>
    )
  }
)
